import { render, staticRenderFns } from "./ConnectWallet.vue?vue&type=template&id=8c11194c&"
import script from "./ConnectWallet.vue?vue&type=script&lang=js&"
export * from "./ConnectWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports